
import { Modal, Table } from 'react-bootstrap';
import { ContactData } from './DataDefinitions';
import avatar from 'assets/img/team/150x150/avatar.webp';
import Avatar from 'components/base/Avatar';
import { Card, Col, Row } from 'react-bootstrap';
import { useState } from 'react';
import Button from 'components/base/Button';
import { useEffect } from 'react';

import apiClient, { handleAPIError } from 'helpers/apiService';
import { useTranslation } from 'react-i18next';
interface ContactPickerModalProps {
    handleClose: () => void;
    show: boolean;
    data: ContactData | undefined;
    onSave: (contact: ContactData) => void;
}

const ContactPickerModal = ({
    handleClose,
    show,
    data,
    onSave
}: ContactPickerModalProps) => {

    const [contacts, setContacts] = useState<ContactData[]>([]);
    const [contact, setContact] = useState<ContactData>();
    const [contactImage, setContactImage] = useState(avatar);

    const [loading, setLoading] = useState(true);

    const { t } = useTranslation();

    const fetchData = async () => {
        try {
            const { data } = await apiClient.get('/v1/contacts');
            setContacts(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const selectContact = async (index: number) => {
        setContact(contacts[index]);
        if (contacts[index].picture)
            //setContactImage(`data:image/jpeg;base64, ${contacts[index].picture}`);
            setContactImage(contacts[index].picture);
    };

    useEffect(() => {
        if (show === true) {
            fetchData();
        }

        if (data) {
            setContact(data);
        }

        if (data && data.picture)
            //setContactImage(`data:image/jpeg;base64, ${data.picture}`);
            setContactImage(data.picture);

    }, [show]);

    const handleSave = (contact: ContactData | undefined) => {
        if (contact === undefined) {
            return;
        }
        onSave(contact);
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            contentClassName="overflow-hidden"
        >
            <Modal.Header className="position-relative p-0">
                <h3 className='m-2'>{t("ContactPickerModal.edit_contact")}</h3>
            </Modal.Header>
            <Modal.Body className="p-4">
                <Row>
                    <Col md={4} xs={4}>

                        <Card bg='light' className='vh-50' >
                            <Card.Body>
                                <Card.Title as="h4" className='text-dark' style={{ textAlign: 'center' }}>
                                    Currenct contact
                                </Card.Title>

                                <Row className="align-items-center g-3 text-center text-xxl-start">
                                    <Col xs={12} className="text-center">
                                        <Avatar size="5xl" src={contactImage} className="d-inline-block" />
                                    </Col>
                                    <Col xs={12} sm="auto" className="flex-1">
                                        {contact && (<>
                                            <h3 className="fw-bolder mb-2">{contact.name}</h3>
                                            <p className="mb-0">{contact.role},</p>
                                            <h4 className="fw-bold text-primary" style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                                                {contact.company_name}
                                            </h4>
                                        </>
                                        )}
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>


                    </Col>
                    <Col>

                        <div className="border-top bg-soft vh-50" style={{ overflow: 'auto' }} >
                            <Table className='phoenix-table fs-9 table' hover size='sm'>
                                <thead>
                                    <tr>
                                        <th className="ps-0" style={{ width: '15%' }}></th>
                                        <th style={{ textAlign: 'center' }}>{t("ContactPickerModal.name")}</th>
                                        <th style={{ textAlign: 'center' }}>{t("ContactPickerModal.company")}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {contacts && contacts.map((contact, index) => {
                                        let contact_pic = avatar;
                                        if (contact.picture)
                                            //contact_pic = `data:image/jpeg;base64, ${contact.picture}`;
                                            contact_pic = contact.picture;

                                        return (
                                            <tr key={index} onClick={() => selectContact(index)}>
                                                <td style={{ textAlign: 'center' }}><Avatar size="2xl" rounded='soft' src={contact_pic} className="d-inline-block" /></td>
                                                <td>{contact.name}</td>
                                                <td>{contact.company_name}</td>
                                            </tr>);
                                    })}
                                </tbody>

                            </Table>
                        </div>



                    </Col>
                </Row>


                <Row className="mt-3">
                    <Col sm={{ span: 6 }}>
                        <Button variant="warning" onClick={handleClose}> Discard changes </Button>
                    </Col>
                    <Col sm={{ span: 6 }} style={{ textAlign: 'right' }}>
                        <Button variant="primary" onClick={() => { handleSave(contact) }}>Save changes </Button>
                    </Col>

                </Row>




            </Modal.Body>
        </Modal >
    );
};

export default ContactPickerModal;